var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:['returnClass', { inApp: _vm.$root.$data.isApp }]},[_c('common-title',{attrs:{"titleName":"课程升级","zIndex":1000}}),_c('replaceClass'),_c('Foot')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }